import React from "react";
import ReactDOM from "react-dom/client";

// Seeds mockTelegramEnv when VITE_DEV_INIT_DATA_RAW is set. Must run before
// any SDK call, so it's the first side-effecting import. Tree-shaken in prod.
if (import.meta.env.DEV) {
  await import("./dev-bootstrap");
}

import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
